import last from "lodash/last";
import sortBy from "lodash/sortBy";
import { EventKey } from "PFTypes/event_key";
import { useEffect } from "react";

const getTopModalElement = () =>
  last(document.getElementById("modal_region")?.querySelectorAll(`[data-modal="true"]`));

const getTopSidePanelElement = () => {
  const openSidePanels = document
    .getElementById("modal_region")
    ?.querySelectorAll(`[data-side-panel="true"]`);
  return last(
    sortBy(openSidePanels, (div: HTMLElement) => parseInt(div.style.getPropertyValue("z-index") || "0"))
  );
};

const getTopDialogElement = () => {
  const lastModalElement = getTopModalElement();
  // any modal is on top of any side panel
  return lastModalElement || getTopSidePanelElement();
};

type UseCloseOnEscapeClick = {
  dialogId: string;
  closeWithAnimation: VoidFunction;
};

export const useCloseDialogOnEscapeKey = ({ dialogId, closeWithAnimation }: UseCloseOnEscapeClick) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const topDialogElement = getTopDialogElement();
      // Avoid closing all the dialogs with single ESC click
      const isTopDialog = dialogId === topDialogElement?.getAttribute("data-dialog-id");

      if (event.key === EventKey.Escape && isTopDialog) {
        event.preventDefault();
        closeWithAnimation();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [dialogId, closeWithAnimation]);
};
